
import * as actionTypes from '../../actions';
import store from '../../index';
import api from 'api';

export const load = async() => {
    return new Promise( async resolve => {

        const loaded = await api.load.standard();

        if(loaded.success) {

            store.dispatch({ type: actionTypes.SET_LOADED, payload: loaded.data });
            resolve({success: true, data: loaded.data});

        } else {

            resolve({success: false});

        }

    })

}
